let qualityForm = () => {

    let module = {},

        init = () => {

            $('#submitContactForm').on('click', (e) => {

                if(! $('.form')[0].checkValidity()) {

                    $('input').each(function () {

                        if (! this.checkValidity()) {
                            $(this).parent().addClass('has-errors');

                            // Checkbox
                            $(this).siblings('.invalid-feedback').slideDown();

                            // Other elements
                            $(this).parent().siblings('.invalid-feedback').slideDown();
                        } else {
                            $(this).parent().removeClass('has-errors');
                            $(this).parent().siblings('.invalid-feedback').slideUp();
                            $(this).siblings('.invalid-feedback').slideUp();
                        }
                    });

                    e.preventDefault();
                } else {
                    e.preventDefault();

                    ga('send', 'event', 'contact-send', 'click', 'webpage');

                    jQuery.post(
                        window.location.origin + '/wp/wp-admin/admin-ajax.php',
                        {
                            'action': 'contact_form',
                            'name':   $('.form #name').val(),
                            'surname': $('.form #surname').val(),
                            'email':   $('.form #email').val(),
                            'message': $('.form #message').val(),
                            'terms':   $('.form #about-us-contact-check').val(),
                            'nonce':   $('.form #nonce').val(),
                            'recaptcha_response':   $('.form .recaptchaResponse').val(),
                            'id': $('.form #id').val()
                        },
                        function(response) {
                            $('#about-contact').hide();
                            $('#about-contact-confirmation').show();

                            $([document.documentElement, document.body]).animate({
                                scrollTop: $('#about-contact-confirmation').offset().top
                            }, 1000);
                        }
                    );

                }
            });

            // Custom form Halal
            $('#submitCustomForm').on('click', (e) => {

                if(! $('.form')[0].checkValidity()) {

                    $('input, textarea').each(function () {

                        if (! this.checkValidity()) {
                            $(this).parent().addClass('has-errors');

                            // Checkbox
                            $(this).siblings('.invalid-feedback').slideDown();

                            // Other elements
                            $(this).parent().siblings('.invalid-feedback').slideDown();
                        } else {
                            $(this).parent().removeClass('has-errors');
                            $(this).parent().siblings('.invalid-feedback').slideUp();
                            $(this).siblings('.invalid-feedback').slideUp();
                        }
                    });

                    e.preventDefault();
                } else {
                    e.preventDefault();

                    ga('send', 'event', 'custom-send', 'click', 'webpage');

                    jQuery.post(
                        window.location.origin + '/wp/wp-admin/admin-ajax.php',
                        {
                            'action': 'custom_form',
                            'name':   $('.form #name').val(),
                            'surname': $('.form #surname').val(),
                            'location': $('.form #location').val(),
                            'email':   $('.form #email').val(),
                            'message': $('.form #message').val(),
                            'terms':   $('.form #about-us-contact-check').val(),
							'recaptcha_response':   $('.form .recaptchaResponse').val(),
                            'nonce':   $('.form #nonce').val()
                        },
                        function(response) {
                            response = JSON.parse(response);
                            $('#about-contact').hide();
                            $('#about-contact-confirmation').show();
                            $('#customFormData').val(response.post);

                            $([document.documentElement, document.body]).animate({
                                scrollTop: $('#about-contact-confirmation').offset().top
                            }, 1000);
                        }
                    );

                }
            });

            // German campaing from top
            $('#form-1-submit').on('click', (e) => {

                if(! $('#german_campaign-form-1')[0].checkValidity()) {

                    $('#german_campaign-form-1 input, #german_campaign-form-1 textarea').each(function () {

                        if (! this.checkValidity()) {
                            $(this).parent().addClass('has-errors');

                            // Checkbox
                            $(this).siblings('.invalid-feedback').slideDown();

                            // Other elements
                            $(this).parent().siblings('.invalid-feedback').slideDown();
                        } else {
                            $(this).parent().removeClass('has-errors');
                            $(this).parent().siblings('.invalid-feedback').slideUp();
                            $(this).siblings('.invalid-feedback').slideUp();
                        }
                    });

                    e.preventDefault();
                } else {
                    e.preventDefault();

                    ga('send', 'event', 'flavor-form-submit', 'click', 'webpage');

                    var ajaxData = new FormData();

                    ajaxData.append('action', 'campaign_flavor');
                    ajaxData.append('name', $('#german_campaign-form-1 #name').val());
                    ajaxData.append('last_name', $('#german_campaign-form-1 #last').val());
                    ajaxData.append('email', $('#german_campaign-form-1 #email').val());
                    ajaxData.append('address', $('#german_campaign-form-1 #street').val());
                    ajaxData.append('city', $('#german_campaign-form-1 #city').val());
                    ajaxData.append('postcode', $('#german_campaign-form-1 #postalcode').val());
                    ajaxData.append('flavor', $('#german_campaign-form-1 #flavor').val());
                    ajaxData.append('nonce', $('#german_campaign-form-1 #nonce').val());
                    ajaxData.append('recaptcha_response', $('#german_campaign-form-1 .recaptchaResponse').val());
                    ajaxData.append('id', $('#german_campaign-form-1 #id').val());

                    $.ajax({
                        url: window.location.origin + '/wp/wp-admin/admin-ajax.php',
                        data: ajaxData,
                        processData: false,
                        contentType: false,
                        type: 'POST',
                        success: function (data) {
                            $('#form-block-1').attr('style','display:none !important');
                            $('#form-confirmation-1').attr('style','display:block !important');

                            $([document.documentElement, document.body]).animate({
                                scrollTop: $('#form-confirmation-1').offset().top - 100
                            }, 1000);
                        },
                        error: function (e) {
                            let errorCode = e.responseJSON.data.error;

                            if (errorCode == 3) {
                                $('#form-block-1 .invalid-flavor').slideDown();
                            } else {
                                $('#form-block-1 .invalid-email').slideDown();
                            }
                        }
                    });

                }
            });

            $('#form-2-submit').on('click', (e) => {

                if(! $('#german_campaign-form-2')[0].checkValidity()) {

                    $('#german_campaign-form-2 input, #german_campaign-form-2 textarea').each(function () {

                        if (! this.checkValidity()) {
                            $(this).parent().addClass('has-errors');

                            // Checkbox
                            $(this).siblings('.invalid-feedback').slideDown();

                            // Other elements
                            $(this).parent().siblings('.invalid-feedback').slideDown();
                        } else {
                            $(this).parent().removeClass('has-errors');
                            $(this).parent().siblings('.invalid-feedback').slideUp();
                            $(this).siblings('.invalid-feedback').slideUp();
                        }
                    });

                    e.preventDefault();
                } else {
                    e.preventDefault();

                    ga('send', 'event', 'flavor-form-submit', 'click', 'webpage');

                    var ajaxData = new FormData();

                    ajaxData.append('action', 'campaign_flavor');
                    ajaxData.append('name', $('#german_campaign-form-2 #name').val());
                    ajaxData.append('last_name', $('#german_campaign-form-2 #last').val());
                    ajaxData.append('email', $('#german_campaign-form-2 #email').val());
                    ajaxData.append('address', $('#german_campaign-form-2 #street').val());
                    ajaxData.append('city', $('#german_campaign-form-2 #city').val());
                    ajaxData.append('postcode', $('#german_campaign-form-2 #postalcode').val());
                    ajaxData.append('flavor', $('#german_campaign-form-2 #flavor').val());
                    ajaxData.append('nonce', $('#german_campaign-form-2 #nonce').val());
                    ajaxData.append('recaptcha_response', $('#german_campaign-form-2 .recaptchaResponse').val());
                    ajaxData.append('id', $('#german_campaign-form-2 #id').val());

                     $.ajax({
                        url: window.location.origin + '/wp/wp-admin/admin-ajax.php',
                        data: ajaxData,
                        processData: false,
                        contentType: false,
                        type: 'POST',
                        success: function (data) {
                            $('#form-block-2').attr('style','display:none !important');
                            $('#form-confirmation-2').attr('style','display:block !important;margin-bottom:128px;');

                            $([document.documentElement, document.body]).animate({
                                scrollTop: $('#form-confirmation-2').offset().top - 100
                            }, 1000);
                        },
                        error: function (e) {
                            let errorCode = e.responseJSON.data.error;

                            if (errorCode == 3) {
                                $('#form-block-1 .invalid-flavor').slideDown();
                            } else {
                                $('#form-block-1 .invalid-email').slideDown();
                            }
                        }
                    });

                }
            });
        };

    module.init = init;

    return module;

};

export default qualityForm();